import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// JS Files

// Others File
import notificationsIcon from "../../imgs/notifications.svg";

const NotificationsCard = ({ item }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="border border-myorange-400 rounded-lg  flex flex-col items-center justify-center">
        <div className="flex items-center mt-4">
          <img src={notificationsIcon} className="w-12 h-12" />
          <p className="mr-2 text-mygray-700 font-bold">{item.title}</p>
        </div>
        <p className="text-sm leading-8 text-mygray-700 m-6">
          {item.description.substring(1, 150)} ...
        </p>
        <div
          onClick={() => navigate(`/notifications-details/${item.id}`)}
          className="flex items-center justify-center bg-mygray-100 mt-4 w-full rounded-b-lg p-2 cursor-pointer"
        >
          <span className=" text-myorange-500 font-bold">اطلاعات بیشتر</span>
        </div>
      </div>
    </>
  );
};
export default NotificationsCard;
